import {useTranslation} from 'react-i18next';
import {useMutation} from 'react-query';
import services from '../../services/provider';
import useLocalStorageState from './use-local-storage-state';
import useUser from './use-user';

function useLanguage() {
  const {i18n} = useTranslation();

  const {user} = useUser();

  const [, setLanguage] = useLocalStorageState('language', 'en');

  const {mutate: updateUser} = useMutation({
    mutationFn: services.user.updateUser,
  });

  function changeLanguage(language: string) {
    i18n.changeLanguage(language);
    setLanguage(language);
    if (user != null) {
      user.language = language;
      updateUser({
        params: {userId: user.id},
        request: user,
      });
    }
  }

  return [i18n.language, changeLanguage] as const;
}

export default useLanguage;
